__turbopack_context__.v({
  "priceRefinementRoot": "PriceRefinement-module-scss-module__6Wm0za__priceRefinementRoot",
});
